module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot479-2560x1440.ab8af9dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot479-2560x1440.jpg
// module id = 1073
// module chunks = 37